import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { FaSpinner, FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import { setUser } from "../store/slices/authSlice";
import toast from "react-hot-toast";

const OAuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [status, setStatus] = useState("loading");
  const [error, setError] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get("token");
    const userParam = params.get("user");

    if (token && userParam) {
      try {
        const user = JSON.parse(decodeURIComponent(userParam));
        localStorage.setItem("token", token);
        dispatch(setUser(user));
        setStatus("success");
        toast.success("Login successful!");

        setTimeout(() => {
          navigate("/dashboard");
        }, 1500);
      } catch (err) {
        setStatus("error");
        setError("Failed to process authentication");
        toast.error("Authentication failed");
      }
    } else if (window.opener) {
      // This is a popup that didn't get closed properly
      window.close();
    } else {
      const errorMsg = params.get("error");
      setStatus("error");
      setError(errorMsg || "Authentication failed");
      toast.error("Authentication failed");

      setTimeout(() => {
        navigate("/login");
      }, 3000);
    }
  }, [location, navigate, dispatch]);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      }}
    >
      <div
        style={{
          background: "white",
          borderRadius: "20px",
          padding: "3rem",
          textAlign: "center",
          maxWidth: "400px",
          width: "90%",
          boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
        }}
      >
        {status === "loading" && (
          <>
            <FaSpinner
              size={50}
              style={{ animation: "spin 1s linear infinite", color: "#8b5cf6" }}
            />
            <h2 style={{ marginTop: "1rem", color: "#333" }}>
              Authenticating...
            </h2>
            <p style={{ color: "#666", marginTop: "0.5rem" }}>
              Please wait while we log you in
            </p>
          </>
        )}

        {status === "success" && (
          <>
            <FaCheckCircle size={50} color="#10b981" />
            <h2 style={{ marginTop: "1rem", color: "#333" }}>Success!</h2>
            <p style={{ color: "#666", marginTop: "0.5rem" }}>
              Redirecting to dashboard...
            </p>
          </>
        )}

        {status === "error" && (
          <>
            <FaTimesCircle size={50} color="#ef4444" />
            <h2 style={{ marginTop: "1rem", color: "#333" }}>
              Authentication Failed
            </h2>
            <p style={{ color: "#666", marginTop: "0.5rem" }}>
              {error || "Something went wrong"}
            </p>
            <button
              onClick={() => navigate("/login")}
              style={{
                marginTop: "1.5rem",
                padding: "0.75rem 1.5rem",
                background: "#8b5cf6",
                color: "white",
                border: "none",
                borderRadius: "10px",
                cursor: "pointer",
              }}
            >
              Back to Login
            </button>
          </>
        )}
      </div>

      <style>
        {`
          @keyframes spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};

export default OAuthCallback;
